import { ArrowRight } from "lucide-react";

const METRICS = [
    { v: "100%", l: "Foco técnico" },
    { v: "24/7", l: "Resposta rápida" },
    { v: "5.0", l: "Avaliação média" },
];

const AboutMetrics = () => (
    <div className="grid grid-cols-3 gap-px bg-black/10 border border-black/10 mb-10">
        {METRICS.map((m, i) => (
            <div
                key={m.l}
                className="bg-white p-6 md:p-8 text-center"
                data-testid={`about-metric-${i}`}
            >
                <div className="font-display text-3xl md:text-5xl font-black text-[#9B2C2C] mb-2">
                    {m.v}
                </div>
                <div className="text-xs text-[#0A0A0A]/50 uppercase tracking-widest">
                    {m.l}
                </div>
            </div>
        ))}
    </div>
);

const About = () => (
    <section
        id="sobre"
        data-testid="about-section"
        className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-white"
    >
        <div className="max-w-5xl mx-auto reveal">
            <div className="flex items-center gap-3 mb-6">
                <span className="block w-12 h-px bg-[#9B2C2C]" />
                <span className="label-tag" style={{ color: "#9B2C2C" }}>
                    Sobre a Lavlimpar
                </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95] mb-10 text-[#0A0A0A]">
                Higiene, segurança e{" "}
                <span className="text-[#2E7D5B]">eficiência</span> em cada
                intervenção.
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
                <p className="text-[#0A0A0A]/70 text-base md:text-lg leading-relaxed font-light">
                    A Lavlimpar nasceu com o objetivo de oferecer serviços de limpeza
                    técnica profissional com elevados padrões de qualidade. Trabalhamos
                    diariamente para garantir a segurança, higiene e eficiência dos
                    sistemas de extração em cozinhas profissionais.
                </p>
                <p className="text-[#0A0A0A]/70 text-base md:text-lg leading-relaxed font-light">
                    A nossa equipa aposta na atenção ao detalhe, utilização de produtos
                    adequados e métodos eficazes para entregar resultados visíveis e
                    duradouros.
                </p>
            </div>

            <AboutMetrics />

            <a
                data-testid="about-cta"
                href="#contacto"
                className="group inline-flex items-center gap-3 bg-[#9B2C2C] text-white hover:bg-[#B83535] transition-all font-bold tracking-wider uppercase text-xs px-8 py-5"
            >
                Agendar Intervenção
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
        </div>
    </section>
);

export default About;
